import { Grid } from "@material-ui/core"
import { StaticImage } from "gatsby-plugin-image"
import React from "react"
import {
  StyledDetailHeader,
  StyledDetailLocation,
  StyledDetailSubheader,
  StyledDetailSubheaderContent,
} from "./MapTypography"
import { Image } from "react-image-and-background-image-fade"
import cdfinance_logo from "../../images/cd-finance-logo.png"
import no_poverty from "../../images/no-poverty.png"
import decent_work from "../../images/decent-work.png"
import reduced_inequalities from "../../images/reduced-inequalities.png"
import styled from "styled-components"
import { breakpoint } from "../../utils/breakpoint"

const StyledInvestmentThemeWrapper = styled.div`
  width: 100%;
  border-bottom: 2px solid #0f6494;
  padding-top: 8px;
  padding-bottom: 8px;

  ${breakpoint.lg} {
    border-bottom: 3px solid #0f6494;
    padding-top: 12px;
    padding-bottom: 12px;
  }
`

const CdFinanceMapDetailMobile = () => {
  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <div style={{ width: "50%", marginBottom: "5%" }}>
            <Image
              src={cdfinance_logo}
              width="865px"
              height="306px"
              isResponsive
              disableLoader
              lazyLoad
              alt="CD finance"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
          </div>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <div style={{ marginBottom: "1%" }}>
          <StyledDetailHeader>Microfinance</StyledDetailHeader>
        </div>
      </Grid>
      <Grid item xs={12}>
        <StyledDetailLocation>Based in China</StyledDetailLocation>
      </Grid>
      <Grid container>
        <Grid item xs={12} container alignItems="center">
          <StyledInvestmentThemeWrapper>
            <Grid item xs={12}>
              <div style={{ marginBottom: "1%" }}>
                <StyledDetailSubheader>Investment Theme</StyledDetailSubheader>
              </div>
            </Grid>
            <Grid item xs={12}>
              <StyledDetailSubheaderContent>
                Financial & Digital Inclusion
              </StyledDetailSubheaderContent>
            </Grid>
          </StyledInvestmentThemeWrapper>
        </Grid>
        <Grid item xs={12}>
          <StyledDetailSubheader style={{ marginTop: "16px" }}>
            About the Company
          </StyledDetailSubheader>
          <StyledDetailSubheaderContent>
            Microfinance institution providing financial services to rural
            populations in China
          </StyledDetailSubheaderContent>
          <StyledDetailSubheader style={{ marginTop: "16px" }}>
            Impact Thesis
          </StyledDetailSubheader>
          <StyledDetailSubheaderContent>
            Providing access to safe and affordable solutions to boost economic
            growth in rural China while reducing poverty and inequalities
          </StyledDetailSubheaderContent>
        </Grid>
      </Grid>
      <div style={{ width: "100%", marginTop: "10%" }}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Image
              src={no_poverty}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="no poverty"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
          </Grid>
          <Grid item xs={3}>
            <Image
              src={decent_work}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="decent work and economic growth"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
          </Grid>
          <Grid item xs={3}>
            <Image
              src={reduced_inequalities}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="reduced inequalities"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
          </Grid>
        </Grid>
      </div>
    </>
  )
}

export default CdFinanceMapDetailMobile
